
const MIGRATELP_ADDRESS = '0x178Ce573e0D702433258a9637d9902036B940722'

const MIGRATE_WPSC = '0xF4C9ad4cf3595ddaCDe89B6dE8d7cf8d948dA9DB'

const MIGRATE_USDT = '0x9a00EbF48666227e87bf2E1951823666CD3D474e'

export {MIGRATELP_ADDRESS,MIGRATE_USDT,MIGRATE_WPSC}